
const conciseAddress=(str='')=>{
    return `${str.slice(0,6)}...${str.slice(-4)}`
}

export const someConciseAddress=(str='')=>{
    return `${str.slice(0,14)}......${str.slice(-10)}`
}

export default conciseAddress;